import React, { Component } from "react";
import classnames from "classnames";

import { Button, ButtonProps } from "./Button";
import * as styles from "./TextButton.scss";

export class TextButton extends Component<ButtonProps> {
    public render() {
        const { className, children, ...props } = this.props;

        return (
            <Button
                className={classnames(styles.text, styles.button, className)}
                {...props}
            >
                {children}
            </Button>
        );
    }
}
